import {AlertGridFilterComponent} from '../../components/custom-metadata-view/components/alert-grid-filter/alert-grid-filter.component';
import {RmeBaseGridFilterComponent} from '../../components/custom-metadata-view/components/rme-base-grid-filter/rme-base-grid-filter.component';
import {UserFilterComponent} from '../../components/custom-metadata-view/components/user-filter/user-filter.component';

export const ColumnTypeFilterMapping = {
  /** String columns with base filter component */
  name: RmeBaseGridFilterComponent,
  api_name: RmeBaseGridFilterComponent,
  full_api_name: RmeBaseGridFilterComponent,
  full_path: RmeBaseGridFilterComponent,
  base_object: RmeBaseGridFilterComponent,
  last_modified_by: RmeBaseGridFilterComponent,
  trigger_type: RmeBaseGridFilterComponent,
  product_name: RmeBaseGridFilterComponent,
  product_family: RmeBaseGridFilterComponent,
  product_code: RmeBaseGridFilterComponent,
  product_sku: RmeBaseGridFilterComponent,
  llm: RmeBaseGridFilterComponent,
  encryption_scheme: RmeBaseGridFilterComponent,
  business_status: RmeBaseGridFilterComponent,
  data_owner: RmeBaseGridFilterComponent,
  compliance_group: RmeBaseGridFilterComponent,
  data_sensitivity: RmeBaseGridFilterComponent,
  description: RmeBaseGridFilterComponent,
  help_text: RmeBaseGridFilterComponent,
  metadata_id: RmeBaseGridFilterComponent,
  metadata_long_id: RmeBaseGridFilterComponent,
  summary: RmeBaseGridFilterComponent,
  reports_to: RmeBaseGridFilterComponent,
  user_license: RmeBaseGridFilterComponent,
  /** Integer columns */
  test_coverage: RmeBaseGridFilterComponent,
  total_complexity: RmeBaseGridFilterComponent,
  api_version: RmeBaseGridFilterComponent,
  assigned_users: RmeBaseGridFilterComponent,
  record_count: RmeBaseGridFilterComponent,
  fault_coverage: RmeBaseGridFilterComponent,
  summary_info_objects: RmeBaseGridFilterComponent,
  length: RmeBaseGridFilterComponent,
  percent_filled: RmeBaseGridFilterComponent,
  trigger_order: RmeBaseGridFilterComponent,
  capacity: RmeBaseGridFilterComponent,
  priority: RmeBaseGridFilterComponent,
  /** Date columns */
  last_modified_date: RmeBaseGridFilterComponent,
  created_date: RmeBaseGridFilterComponent,
  last_modified_record_date: RmeBaseGridFilterComponent,
  last_created_record_date: RmeBaseGridFilterComponent,
  last_used: RmeBaseGridFilterComponent,
  last_executed_date: RmeBaseGridFilterComponent,
  /** Query columns */
  // Need to implement specific filter component
  parent_object: RmeBaseGridFilterComponent,
  parent_manage_package: RmeBaseGridFilterComponent,
  /** Tags column */
  tags: RmeBaseGridFilterComponent,
  /** Predefined columns */
  type: RmeBaseGridFilterComponent,
  immediate_run: RmeBaseGridFilterComponent,
  is_test: RmeBaseGridFilterComponent,
  async_run: RmeBaseGridFilterComponent,
  active: RmeBaseGridFilterComponent,
  status: RmeBaseGridFilterComponent,
  subtype: RmeBaseGridFilterComponent,
  version_number: RmeBaseGridFilterComponent,
  last_refreshed_date: RmeBaseGridFilterComponent,
  encrypted: RmeBaseGridFilterComponent,
  required: RmeBaseGridFilterComponent,
  complexity_score_level: RmeBaseGridFilterComponent,
  has_help_text: RmeBaseGridFilterComponent,
  has_description: RmeBaseGridFilterComponent,
  impact: RmeBaseGridFilterComponent,
  manage_package: RmeBaseGridFilterComponent,
  is_formula_field: RmeBaseGridFilterComponent,
  is_history_enabled: RmeBaseGridFilterComponent,
  custom_settings_type: RmeBaseGridFilterComponent,
  default_internal_access: RmeBaseGridFilterComponent,
  default_external_access: RmeBaseGridFilterComponent,
  admin_approved_users_only: RmeBaseGridFilterComponent,
  optimization_status: RmeBaseGridFilterComponent, // todo should be specific predefined component or make Predefined more generic
  /** Access Change Monitoring alert columns */
  operation: AlertGridFilterComponent,
  policyName: AlertGridFilterComponent,
  detectedAt: AlertGridFilterComponent,
  performedByName: AlertGridFilterComponent,
  controllerName: AlertGridFilterComponent,
  usersCount: AlertGridFilterComponent,
  access: AlertGridFilterComponent,
  entityName: AlertGridFilterComponent,
  severity: AlertGridFilterComponent,
  category: AlertGridFilterComponent,
  'governanceAssessment.status': AlertGridFilterComponent,
  /** User columns */
  node_assignee: UserFilterComponent
};
